// Utility to generate consistent, name-based initial avatars (so brokers without an uploaded
// photo don't all look like the same stock person).
// We use ui-avatars.com which is free, no auth, and serves SVG/PNG instantly.

const PALETTE = [
    { bg: "002657", fg: "DAA520" }, // navy + gold (brand)
    { bg: "DAA520", fg: "002657" }, // gold + navy
    { bg: "1F3A5F", fg: "F2E9D0" }, // deep blue + cream
    { bg: "0F4C5C", fg: "FFD166" }, // teal + amber
    { bg: "5C0029", fg: "F2E9D0" }, // wine + cream
    { bg: "344E41", fg: "DAD7CD" }, // forest + sand
];

function hashString(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return h;
}

/**
 * Get a profile avatar URL for a user-like object.
 * @param {{ avatar_url?: string|null, name?: string, email?: string, id?: string }} user
 * @param {number} size  pixel size (default 256)
 * @returns {string} absolute image URL — uses the user's real avatar_url if set, otherwise
 *                  an auto-generated initials avatar that is unique per name.
 */
export function profileAvatar(user, size = 256) {
    if (user?.avatar_url) return user.avatar_url;
    const seed = (user?.name || user?.email || user?.id || "GPM").trim();
    const hash = hashString(seed);
    const { bg, fg } = PALETTE[hash % PALETTE.length];
    // ui-avatars query: name, size, background, color, bold, rounded
    const name = encodeURIComponent(seed);
    return `https://ui-avatars.com/api/?name=${name}&size=${size}&background=${bg}&color=${fg}&bold=true&format=svg`;
}
